import { render, staticRenderFns } from "./SaoHei.vue?vue&type=template&id=6a32a46e"
import script from "./SaoHei.vue?vue&type=script&lang=js"
export * from "./SaoHei.vue?vue&type=script&lang=js"
import style0 from "./SaoHei.vue?vue&type=style&index=0&id=6a32a46e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports